import Popover from 'ant-design-vue/es/popover'
import Col from 'ant-design-vue/es/col'
import Row from 'ant-design-vue/es/row'
import Divider from 'ant-design-vue/es/divider'
import { getFroms } from '@/utils/util'
export default {
  name: 'RenderMenu',
  props: ['menuList', 'activeBar'],
  data() {
    return {
      activeTitle: ''
    }
  },
  created() {
    this.activeTitle = this.$route.name
  },
  watch: {},
  methods: {
    changRoute(pTitle, title, path) {
      console.log('path======', path)
      this.$router.push(path)
      // this.activeTitle = title
      this.$emit('change', pTitle)
    }
  },
  render() {
    return (
      <span id="tabMenu">
        {this.menuList.map((item, index) => (
          <Popover
            overlayClassName={'tabPopover'}
            placement={'bottom'}
            content={
              <div>
                {getFroms(item.children).map((from, index, arr) => (
                  <Row>
                    <Col span={6}>
                      {' '}
                      {from.indexOf('http') === -1 ? (
                        <span
                          style={{
                            fontSize: '16px',
                            color: '#333333',
                            fontWeight: 'bold',
                            margin: '5px 0',
                            display: 'inline-block'
                          }}
                        >
                          {from}
                        </span>
                      ) : (
                        <img src={from} />
                      )}{' '}
                    </Col>
                    <Col span={18} style={{ marginBottom: index < arr.length - 1 ? '10px' : '0' }}>
                      {item.children
                        .filter(ite => ite.meta.from === from)
                        .map(it => {
                          return (
                            <a
                              style={{
                                whiteSpace: 'nowrap',
                                display: it.meta.show ? 'inline-block' : 'none',
                                minWidth: '90px',
                                fontSize: '14px',
                                color: '#666666',
                                textAlign: 'left',
                                padding: '0 6px',
                                margin: '6px 0'
                              }}
                              class={{ hover: true, activeTitle: this.activeTitle === it.name }}
                              onClick={e => {
                                // if (it.meta.is_blank === 1) {
                                //   // window.open(it.path)
                                //   this.changRoute(item.meta.title, it.name, it.path)
                                // } else {
                                this.changRoute(item.meta.title, it.name, it.path)
                                // }
                                e.preventDefault()
                              }}
                              href={it.path}
                            >
                              {it.meta.title.indexOf('(') >= 0
                                ? it.meta.title.substr(0, it.meta.title.indexOf('('))
                                : it.meta.title}
                            </a>
                          )
                        })}
                    </Col>
                    {index < arr.length - 1 && <Divider dashed />}
                  </Row>
                ))}
              </div>
            }
            getPopupContainer={() => document.getElementById('tabMenu')}
          >
            <span class={{ tabTitle: true, hover: true, activeBar: this.activeBar === item.meta.title }}>
              {item.meta.title}
            </span>
          </Popover>
        ))}
      </span>
    )
  }
}
